import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/SetPin.css';
import { AppContext } from '../context/AppContext';
// import SaraLogo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import pinIcon from "../assets/icons/pin.png";
import { toast } from 'react-toastify';

function SetPin() {
  const [pin, setPin] = useState('');
  const { setUserPin } = useContext(AppContext);
  const navigate = useNavigate();

  const handleSetPin = () => {
    if (!pin || pin.length !== 4) {
      toast.warn('Please enter a valid 4-digit MPIN');
      return;
    }

    setUserPin(pin);
    navigate('/verify-otp', { replace: true });
  };

  return (
    <>
      <div className='mainhome-screen-wrapper'>
        <div className="top-header">
          Set Your MPIN
        </div>

        <div className="mobile-wrapper">
          <div className='jjj'>
            <div className="illu-box">
              <img src={logo} alt="Set PIN" />
            </div>

            <div className="form-box">
              <div className="pin-input-row">
                <div className="logo-image-wrapper">
                  <img src={pinIcon} alt="pin" className="pin" />
                </div>

                <input
                  id="pin"
                  type="password"
                  inputMode="numeric"
                  maxLength={4}
                  placeholder="Enter New MPIN"
                  value={pin}
                  onChange={(e) =>
                    setPin(e.target.value.replace(/\D/g, '').slice(0, 4))
                  }
                  className="pin-input"
                />
              </div>

              <button className="pin-btn" onClick={handleSetPin}>
                SET PIN
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SetPin;